export default __webpack_public_path__ + "static/media/google.d1e31f45.png";